import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";
import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));

export const birthdayRoutes = [
  {
    page: MainPage,
    path: pathRoutes.birthday.parameter,
    screenCode: SCREEN.IP_020, // using default screen code like others
  },
];
